export default class WindowService {

}
